import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
var DialogContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  background: #000;\n  border-radius: ", "px;\n  opacity: 90%;\n  padding: ", "px;\n  display: flex;\n  color: white;\n  gap: ", "px;\n  font-size: ", "px;\n  ", "\n"], ["\n  position: absolute;\n  background: #000;\n  border-radius: ", "px;\n  opacity: 90%;\n  padding: ", "px;\n  display: flex;\n  color: white;\n  gap: ", "px;\n  font-size: ", "px;\n  ", "\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs2;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxxs;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s2;
}, function (props) {
  var _a, _b;

  return (props === null || props === void 0 ? void 0 : props.onBottom) ? "\n\n  margin-top: ".concat((_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs2, "px;\n  top: 100%;\n  ") : "\n  margin-bottom: ".concat((_b = props.theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs2, "px;\n  bottom: 100%;\n  ");
});
var DialogClose = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  outline: none;\n  border: none;\n  display: inline-block;\n  cursor: pointer;\n  background: transparent;\n  height: ", "px;\n  ", "\n"], ["\n  outline: none;\n  border: none;\n  display: inline-block;\n  cursor: pointer;\n  background: transparent;\n  height: ", "px;\n  ", "\n"])), function (props) {
  var _a;

  return (_a = props.theme.constants) === null || _a === void 0 ? void 0 : _a.toolTipCloseSize;
}, focusVisible);
var templateObject_1, templateObject_2;
export { DialogClose, DialogContainer };